var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('NavigationDrawer'),_c('v-main',{attrs:{"id":"main-content"}},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view',{staticClass:"content"})],1),_c('Loading')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }